// Photos lourdes (brief §5.2) : une photo de telephone depasse vite 10 Mo.
// On la redessine en JPEG, cote long ~2 000 px, AVANT l'envoi — on ne bloque
// jamais quelqu'un sur une erreur de poids qu'on peut eviter.
// Un PDF, ou une image que le navigateur ne sait pas lire (HEIC hors Safari),
// part tel quel : c'est alors le serveur qui tranche, avec un message clair.

const COTE_MAX = 2000
const QUALITE = 0.85
const SEUIL_OCTETS = 1.5 * 1024 * 1024

function chargerImage(fichier) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(fichier)
    const img = new Image()
    img.onload = () => { URL.revokeObjectURL(url); resolve(img) }
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('illisible')) }
    img.src = url
  })
}

export default async function redimensionnerImage(fichier) {
  if (!fichier?.type?.startsWith('image/')) return fichier
  let img
  try {
    img = await chargerImage(fichier)
  } catch {
    return fichier
  }
  const long = Math.max(img.naturalWidth, img.naturalHeight)
  if (long <= COTE_MAX && fichier.size <= SEUIL_OCTETS) return fichier

  const echelle = Math.min(1, COTE_MAX / long)
  const canvas = document.createElement('canvas')
  canvas.width = Math.round(img.naturalWidth * echelle)
  canvas.height = Math.round(img.naturalHeight * echelle)
  const ctx = canvas.getContext('2d')
  // Fond blanc : une image a transparence (PNG) ne doit pas virer au noir en JPEG.
  ctx.fillStyle = 'white'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
  const blob = await new Promise((r) => canvas.toBlob(r, 'image/jpeg', QUALITE))
  if (!blob) return fichier
  const nom = (fichier.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg'
  return new File([blob], nom, { type: 'image/jpeg' })
}
